import React, { useEffect, useRef, useState } from 'react';

import { NextArrow } from '../../assets/NextArrow';
import { PrevArrow } from '../../assets/PrevArrow';
import { useHeaderContext } from '../../HeaderContextProvider';
import MenuItem from '../../MenuItem';
import {
  StyledArrowContainer,
  StyledContainer,
  StyledMenuItems,
  StyledMenuItemsAndArrows,
  StyledMenuItemsAndArrowsContainer,
  StyledMenuItemsContainer,
  StyledEmptySpace,
  StyledOpacityOverlay,
  StyledLogoLink,
} from './styles';

const LogoAndMenuItems = () => {
  const [isScrollArrowVisible, setIsScrollArrowVisible] = useState(false);
  const [showForwardArrow, setShowForwardArrow] = useState(true);
  const [showBackArrow, setShowBackArrow] = useState(false);

  const { colorsPaletteFromBO, routes, appLogo, menuItems, navigate } =
    useHeaderContext();

  const scrollableRef = useRef<null | HTMLInputElement>(null);

  // show the scroll button if our main container is smaller than our content width
  // basically when our scroll bar is shown in overflow auto
  const checkIsScrollable = () => {
    if (
      scrollableRef &&
      scrollableRef.current &&
      scrollableRef.current.scrollWidth > scrollableRef.current.clientWidth
    ) {
      setIsScrollArrowVisible(true);
    } else {
      setIsScrollArrowVisible(false);
    }
  };

  const onScroll = (offset: number) => {
    if (scrollableRef && scrollableRef.current) {
      scrollableRef.current.scrollLeft += offset;
      const { scrollWidth, clientWidth } = scrollableRef.current;
      setShowForwardArrow(
        scrollableRef.current.scrollLeft + clientWidth < scrollWidth,
      );
      setShowBackArrow(scrollableRef.current.scrollLeft > 0);
    }
  };

  useEffect(() => {
    // used to await menu items painting so that the browser can calculate the width of the StyledMenuItems element
    const observer = new MutationObserver(checkIsScrollable);
    if (scrollableRef.current) {
      observer.observe(scrollableRef.current, {
        childList: true,
        subtree: true,
      });
      checkIsScrollable();
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <StyledContainer>
      <StyledLogoLink href={routes.HOME}>{appLogo}</StyledLogoLink>
      <StyledMenuItemsAndArrowsContainer>
        {isScrollArrowVisible && showBackArrow ? (
          <StyledArrowContainer onClick={() => onScroll(-75)}>
            <PrevArrow color="#4e4e4e" size="18" />
          </StyledArrowContainer>
        ) : (
          <StyledEmptySpace />
        )}
        <StyledMenuItemsAndArrows>
          {isScrollArrowVisible && showForwardArrow && (
            <StyledOpacityOverlay position="right" />
          )}
          {isScrollArrowVisible && showBackArrow && (
            <StyledOpacityOverlay position="left" />
          )}
          <StyledMenuItemsContainer ref={scrollableRef}>
            {/* keep children 'div' to detect horizontal scrolling feature */}
            <StyledMenuItems>
              {menuItems.map((menuItem) => (
                <MenuItem
                  menuItem={menuItem}
                  navigate={navigate}
                  colorsPaletteFromBO={colorsPaletteFromBO}
                />
              ))}
            </StyledMenuItems>
          </StyledMenuItemsContainer>
        </StyledMenuItemsAndArrows>
        {isScrollArrowVisible && showForwardArrow && (
          <StyledArrowContainer onClick={() => onScroll(75)}>
            <NextArrow color="#4e4e4e" size="18" />
          </StyledArrowContainer>
        )}
      </StyledMenuItemsAndArrowsContainer>
    </StyledContainer>
  );
};

export default LogoAndMenuItems;
